export default __webpack_public_path__ + "static/media/17.dcc5a1b0.png";